"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeClassNameComponent = makeClassNameComponent;
exports.makeClassNameComponentCustom = makeClassNameComponentCustom;
exports.nameHoc = nameHoc;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../classify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function nameHoc(WrapperComponent, WrappedComponent, hocName) {
  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WrapperComponent.displayName = `${hocName}(${wrappedComponentName})`;
  return WrapperComponent;
}
function makeClassNameComponent(baseClassName) {
  let ComponentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  let name = arguments.length > 2 ? arguments[2] : undefined;
  return /*#__PURE__*/React.forwardRef(
  // $FlowFixMe[escaped-generic]
  nameComponent((_ref, ref) => {
    let {
      className,
      ...props
    } = _ref;
    return (
      /*#__PURE__*/
      // $FlowFixMe[escaped-generic]
      React.createElement(ComponentType, _extends({}, props, {
        ref: ref,
        className: (0, _classify.default)(baseClassName, className)
      }))
    );
  }, `CNC(${name || ComponentType})`));
}
function makeClassNameComponentCustom(baseClassName, ComponentType) {
  return /*#__PURE__*/React.forwardRef(nameHoc((_ref2, ref) => {
    let {
      className,
      ...props
    } = _ref2;
    return /*#__PURE__*/React.createElement(ComponentType, _extends({}, props, {
      ref: ref,
      className: (0, _classify.default)(baseClassName, className)
    }));
  }, ComponentType, 'CNC'));
}
function nameComponent(component, name) {
  component.displayName = name;
  return component;
}